<template>
  <PageOne/>
  <PageTwo/>
  <PageThree/>
</template>

<script>
import PageOne from '@/components/PerformanceManagement/EconomicOperationReport/Holdings/KavehPars/PageOne.vue';
import PageTwo from '@/components/PerformanceManagement/EconomicOperationReport/Holdings/KavehPars/PageTwo.vue';
import PageThree from '@/components/PerformanceManagement/EconomicOperationReport/Holdings/KavehPars/PageThree.vue';

export default {
  components: {
    PageOne,
    PageTwo,
    PageThree,
  },
  data() {
    return {}
  }
}
</script>
